import React, {Component} from 'react';

import './styles.scss';

class Title extends Component {

    render() {
        return (
            <div className={"title"}>{this.props.children}</div>
        );
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/common/title/Title.js